module.exports = __webpack_public_path__ + "img/land_yuanyang.14782bee.png";